<div class="row">

  <div class="col-2">
    <!-- <div class="info-box " (click)="op7.show($event);setDownLines($event,2)"> -->
    <div class="info-box ">
      <span class="info-box-icon text-info"><i class="fas fa-info"></i></span>
      <div class="info-box-content">
        <strong class="info-box-text">Total Lines</strong>
        <span class="info-box-number">{{totalLines}}</span>
      </div>
      <div class="overlay dark" *ngIf="loading" style="width: 100%; height: 100%">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
    </div>
  </div>
  <div class="col-2">
    <div class="info-box ">
      <span class="info-box-icon text-secondary"><i class="fa fa-low-vision"></i></span>
      <div class="info-box-content">
        <strong class="info-box-text">Unmonitored</strong>
        <span class="info-box-number">{{totalUnmonitoredLines}}</span>
      </div>
      <div class="overlay dark" *ngIf="loading" style="width: 100%; height: 100%">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
    </div>
  </div>
  <div class="col-2">
    <!--<div class="info-box " (click)="op7.show($event);setDownLines($event,2)">-->
    <div class="info-box ">
      <span class="info-box-icon text-success"><i class="fas fa-angle-double-up"></i></span>
      <div class="info-box-content">
        <strong class="info-box-text">Up Lines</strong>
        <span class="info-box-number">{{upLines}}</span>
      </div>
      <div class="overlay dark" *ngIf="loading" style="width: 100%; height: 100%">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
    </div>
  </div>
  <div class="col-2">
    <!-- <div class="info-box" (click)="op.show($event);setDownLines($event,0)"> -->
    <div class="info-box">
      <span class="info-box-icon text-danger"><i class="fas fa-angle-double-down"></i></span>
      <div class="info-box-content">
        <strong class="info-box-text">Down Lines</strong>
        <span class="info-box-number">{{downLines}}</span>
      </div>
      <div class="overlay dark" *ngIf="loading" style="width: 100%; height: 100%">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
    </div>
  </div>
  <div class="col-2">
    <!-- <div class="info-box " (click)="op7.show($event);setDownLines($event,2)"> -->
    <div class="info-box ">
      <span class="info-box-icon text-warning"><i class="fas fa-power-off"></i></span>
      <div class="info-box-content">
        <strong class="info-box-text">In Maintenance</strong>
        <span class="info-box-number">{{maintenanceLines}}</span>
      </div>
      <div class="overlay dark" *ngIf="loading" style="width: 100%; height: 100%">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
    </div>
  </div>
  <div class="col-2">
    <div class="info-box ">
      <span class="info-box-icon text-info"><i class="far fa-envelope"></i></span>
      <div class="info-box-content">
        <strong class="info-box-text">Total SRs</strong>
        <span class="info-box-number">{{ticketsNumber}}</span>
      </div>
      <div class="overlay dark" *ngIf="loading" style="width: 100%; height: 100%">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
    </div>
  </div>
</div>
